// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_4o3","cls2":"TranslationModal-cls2_f1e TranslationModal-cls1_4o3"};